module.exports = __webpack_public_path__ + "images/tiper.2f8390a.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/activities/icon/tiper.png
// module id = 634
// module chunks = 0